import { render } from "./EditUserPreferences.vue?vue&type=template&id=d1e88a3a"
import script from "./EditUserPreferences.vue?vue&type=script&lang=js"
export * from "./EditUserPreferences.vue?vue&type=script&lang=js"

import "./EditUserPreferences.vue?vue&type=style&index=0&id=d1e88a3a&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__